<template>
    <component 
        component-name="block" 
        :data-config="useComponentName && config && !(Object.keys(config).length === 0 && config.constructor === Object) ? `config ${JSON.stringify(config)}` : undefined"
        :is="is" 
        class="relative top-0 left-0"
        :class="{
            'before:truncate before:text-body-small before:absolute before:top-0 before:left-0 before:z-50 before:bg-skin-inverted/10 before:p-sm before:text-[blue] before:text-shadow-2xl before:content-[attr(component-name)]': useComponentName,
            'after:truncate after:text-body-tiny after:absolute after:top-14 after:left-0 after:z-50 after:bg-skin-inverted/10 after:p-xs after:text-[red] after:text-shadow-2xl after:content-[attr(data-config)]': useComponentName && !(Object.keys(config).length === 0 && config.constructor === Object)
        }">
        <slot 
            :loading="loading"
            :config="config" 
            :data="data" 
        />
    </component>
</template>

<script setup>
const props = defineProps({
    is: {
        type: String,
        required: false,
        default: 'section'
    },
    loading: {
        type: String,
        required: false,
        validator: function (value) {
            return ["auto", "lazy"].indexOf(value) !== -1;
        },
        default: 'auto'
    },
    config: {
        type: Object,
        required: false,
        default: function() {
            return {};
        }
    },
    data: {
        type: Object,
        required: false,
    },
    useComponentName: {
        type: Boolean,
        required: false,
        default: false
    }
});
</script>